module.exports = __webpack_public_path__ + "img/bg-sobre_dois.593b8934.jpg";